import { add, addWrapRect, updateWrapRect } from './set';
import {
    size,
    has,
    getAll,
    getSelectWrapRect,
    isEmpty,
    getSelectedByType,
    allSelectedType
} from './get';
import { clear, remove } from './delete';

export {
    add,
    size,
    has,
    getAll,
    clear,
    remove,
    getSelectWrapRect,
    addWrapRect,
    isEmpty,
    getSelectedByType,
    allSelectedType,
    updateWrapRect
}

export default {
    add,
    size,
    has,
    getAll,
    clear,
    remove,
    getSelectWrapRect,
    addWrapRect,
    isEmpty,
    getSelectedByType,
    allSelectedType,
    updateWrapRect
}
